export const LEGAL_ENTITY = "Vision & Expansion AV Systems LLC";
export const LEGAL_JURISDICTION = { es: "Estado de Oklahoma, EE. UU.", en: "State of Oklahoma, USA" };
export const SUPPORT_EMAIL = "support@urbis.shop";

export function LegalLayout({ title, updated, children }) {
  return (
    <div className="mx-auto max-w-3xl px-6 py-12" data-testid="legal-page">
      <h1 className="font-head text-4xl font-extrabold text-secondary sm:text-5xl">{title}</h1>
      <p className="mt-2 text-sm text-slate-400">{updated}</p>
      <div className="prose prose-slate mt-8 max-w-none text-slate-600 [&_h2]:mt-8 [&_h2]:font-head [&_h2]:text-xl [&_h2]:font-bold [&_h2]:text-secondary [&_p]:mt-3 [&_li]:mt-1 [&_ul]:mt-2 [&_ul]:list-disc [&_ul]:pl-6">
        {children}
      </div>
    </div>
  );
}
